import React from 'react';
import { Radio } from 'antd';
import FormItem from './FormItem';
import NotEditableItem from './NotEditableItem';

export default function FormRadio({ editable, name, value, error, onChange, layout, label, required, className, ...props }) {
  if (!editable) {
    return (
      <NotEditableItem title={props.placeholder} value={value} />
    );
  }

  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
      className={className}
    >
      <Radio.Group
        name={name}
        value={value}
        onChange={onChange}
        {...props}
      />
    </FormItem>
  );
}

FormRadio.prepareOptions = prepareOptions;

function prepareOptions(data) {
  if (data) {
    if (!Array.isArray(data)) {
      throw new Error('Wrong data for Radio');
    }

    return data.map(({ name, ...props }) => (
      <Radio key={name} {...props}>{name}</Radio>
    ));
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/Radio.js